import React, { HTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { DeleteIcon, ITheme } from '../../../../../ui';
import themed from '../../../../../ui/themer/themed';

export const StyledDeleteCardButton = styled.div<{}, ITheme>`
	padding: 8px;
	margin-top: -8px;
	margin-right: -8px;
	transition: 0.2s background;
	border-radius: 100%;

	svg {
		display: block;
	}

	&:hover {
		background: ${themed(({ color }) => color.background.hover)};
	}
`;

export interface IDeleteCardButtonProps
	extends HTMLAttributes<HTMLDivElement> {}

export const DeleteCardButton = (props: IDeleteCardButtonProps) => (
	<StyledDeleteCardButton {...props}>
		<DeleteIcon variation="error" />
	</StyledDeleteCardButton>
);
